<div class="address-input-container">
  <ig-field #inputElement [label]="label" [hint]="hint" [icon]="control.value ? 'clear' : 'room'"
    (onIconClick)="clear()" [control]="control" autocomplete="off" autocorrect="off" autocapitalize="off"
    spellcheck="false" type="text"></ig-field>
</div>